export function presignedUrlSameAsset(
  a: string | undefined | null,
  b: string | undefined | null
): boolean {
  if (!a || !b) {
    return false
  }
  try {
    const ua = new URL(a)
    const ub = new URL(b)
    return ua.origin === ub.origin && ua.pathname === ub.pathname
  } catch {
    return a === b
  }
}

export function presignedUrlAssetKey(url: string | undefined | null): string {
  if (!url) {
    return ""
  }
  try {
    const u = new URL(url)
    return `${u.origin}${u.pathname}`
  } catch {
    return url
  }
}

export const validateUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url)

    const allowedSchemes = ["http:", "https:"]
    const dangerousCharacters = /[<>]/

    if (
      !allowedSchemes.includes(parsedUrl.protocol) ||
      dangerousCharacters.test(parsedUrl.href)
    ) {
      return ""
    }

    return parsedUrl.href
  } catch (e) {
    return ""
  }
}
